export default function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/date.js
// module id = 470
// module chunks = 0